/**
 * Class accordion
 */
class Accordion {
	transition: number;
	mobileTriggers: JQuery;
	triggers: JQuery;
	accordion: JQuery;

	constructor(element: JQuery) {
		this.accordion = element;
		this.initBorder();
		this.adjustContentHeight();
		this.mobileTriggers = this.accordion.find('.block-bellow__top');
		this.mobileTriggers.on('click', this.handleBellowClick.bind(this));
		this.triggers = this.accordion.find('.desktop-tabs__button');
		this.triggers.on('click', this.handleTabClick.bind(this));
		this.transition = 400;
		this.accordion
			.find('.tabs > .block-bellow:first-child > .block-bellow__collapsable')
			.addClass('active');
		this.accordion
			.find('.tabs > .block-bellow:first-child > .block-bellow__collapsable')
			.css('display', 'block');
		this.accordion.find('.tabs > .block-bellow:first-child').addClass('block-bellow--expanded');
	}

	/**
	 * Initializes the border height for the accordion buttons.
	 *
	 */
	initBorder() {
		const buttonHeight = this.accordion.find('.desktop-tabs__button').outerHeight();
		const border = this.accordion.find('.active-border');
		border.css({
			height: buttonHeight + 'px',
		});
	}

	/**
	 * Adjusts the height of the accordion content based on the height of the controls.
	 *
	 */
	adjustContentHeight() {
		const controlsHeight =
			this.accordion.find('.block-accordion__content-wrapper').outerHeight() || 0;
		this.accordion.find('.block-accordion__content').css('height', controlsHeight);
	}

	/**
	 * Handle bellow click
	 *
	 * @param {Event} event
	 */
	handleBellowClick(event: Event) {
		const target = event.currentTarget as Element;

		const isExpanded = target
			?.closest('.block-bellow')
			?.classList.contains('block-bellow--expanded');

		if (isExpanded) {
			this.collapseBellow(target);
		} else {
			this.expandBellow(target);
		}
	}

	/**
	 * Handle tab click
	 *
	 * @param {Event} event
	 */
	handleTabClick(event: Event) {
		const target = event.currentTarget as Element;
		this.closeTabs();
		this.openTab(target);
		this.moveBorder(target);
	}

	/**
	 * Close other tabs
	 *
	 */
	closeTabs() {
		const activeTab = this.accordion.find('.block-bellow__collapsable.active');
		const button = this.accordion.find('.desktop-tabs__button[aria-expanded="true"]');
		button.attr('aria-expanded', 'false');
		activeTab.removeClass('active');
	}

	/**
	 * Close Tab
	 *
	 * @param {HTMLElement} element Tab button
	 */
	openTab(element: Element) {
		const tabButton = $(element);
		const tab = this.accordion.find('[aria-labelledby="' + tabButton.attr('id') + '"]');
		tabButton.attr('aria-expanded', 'true');
		tab.addClass('active');
	}

	/**
	 * Moves the border element to the position of the specified element.
	 *
	 * @param {HTMLElement} element - The element to which the border should be moved.
	 */
	moveBorder(element: Element) {
		const buttonPosition = $(element).position().top;
		const buttonHeight = $(element).outerHeight();
		const border = this.accordion.find('.active-border');
		const borderHeight = border.outerHeight();

		if (borderHeight !== buttonHeight) {
			border.css('height', buttonHeight + 'px');
		}

		border.css('top', buttonPosition + 'px');
	}

	/**
	 * Collapse Bellow
	 *
	 * @param {HTMLElement} element Event target
	 */
	collapseBellow(element: Element) {
		const bellowTrigger = $(element);

		bellowTrigger
			.attr('aria-expanded', 'false')
			.parents('.block-bellow')
			.removeClass('block-bellow--expanded')
			.find('.block-bellow__collapsable')
			.slideUp(this.transition);
	}

	/**
	 * Expand Bellow
	 *
	 * @param {HTMLElement} element Event target
	 */
	expandBellow(element: Element) {
		const bellow = $(element);

		// Collapse other bellow if exists and not multiple open by default.
		const expandedBellow = document.querySelector('.block-bellow--expanded .block-bellow__top');
		if (null !== expandedBellow && $('.block-bellow--open-default').length < 2) {
			this.collapseBellow(expandedBellow);
		}

		// Expand bellow.
		bellow
			.attr('aria-expanded', 'true')
			.parents('.block-bellow')
			.addClass('block-bellow--expanded')
			.find('.block-bellow__collapsable')
			.slideDown(this.transition);
	}
}

const accordions: Accordion[] = [];

$('.block-accordion').each(function () {
	const accordionInstance = new Accordion($(this));
	accordions.push(accordionInstance);
});

$(window).resize(() => {
	accordions.forEach((accordion) => accordion.initBorder());
	accordions.forEach((accordion) => accordion.adjustContentHeight());
});
